import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useRef, useEffect, useState } from 'react';
import { FilterOptionSource } from '../../common/filters/types';
import { addFilters as addFiltersAction, replaceAllFilters as replaceAllFiltersAction, updateFilterState, useFilter } from '../../common/filters/use-filters';
import { useSessionUserInput } from '../user-input-provider';
export var useFilterStore = function useFilterStore() {
  var defaultFilters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var productId = arguments.length > 1 ? arguments[1] : undefined;
  var filterType = arguments.length > 2 ? arguments[2] : undefined;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useSessionUserInput = useSessionUserInput(),
    stickySearchEnabled = _useSessionUserInput.stickySearchEnabled,
    readFilters = _useSessionUserInput.readFilters,
    storeFilters = _useSessionUserInput.storeFilters;
  var storedFilters = readFilters(productId) ? readFilters(productId)[filterType] : [];
  var defaultFiltersRef = useRef(stickySearchEnabled && storedFilters && storedFilters.length > 0 ? storedFilters : defaultFilters);
  var _useFilter = useFilter(defaultFiltersRef.current),
    filters = _useFilter.filters,
    dispatch = _useFilter.dispatch;
  var addFilters = useCallback(function (newFilters) {
    return dispatch(addFiltersAction(newFilters, function (a, b) {
      if (a.filterSource === FilterOptionSource.CURRENT_USER && b.filterSource !== FilterOptionSource.CURRENT_USER) {
        return -1;
      }
      if (a.filterSource !== FilterOptionSource.CURRENT_USER && b.filterSource === FilterOptionSource.CURRENT_USER) {
        return 1;
      }
      return 0;
    }));
  }, [dispatch]);
  var loadDefaultFilters = function loadDefaultFilters(load) {
    setIsLoading(true);
    load.then(function (result) {
      return setDefaultFilters(result);
    }).finally(function () {
      return setIsLoading(false);
    });
  };
  var updateFilter = useCallback(function (id, isChecked) {
    var isVisible = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return dispatch(updateFilterState(id, isChecked, isVisible));
  }, [dispatch]);
  var updateSingleValueFilter = useCallback(function (id) {
    filters.forEach(function (f) {
      return dispatch(updateFilterState(f.id, f.id === id));
    });
  }, [filters, dispatch]);
  var clearFilter = useCallback(function () {
    filters.forEach(function (f) {
      return dispatch(updateFilterState(f.id, false));
    });
  }, [filters, dispatch]);
  var resetFilter = useCallback(function () {
    dispatch(replaceAllFiltersAction(defaultFilters.length ? defaultFilters : defaultFiltersRef.current));
  }, [defaultFilters, dispatch]);
  var setDefaultFilters = useCallback(function (filters) {
    defaultFiltersRef.current = filters;
    resetFilter();
  }, [defaultFiltersRef, resetFilter]);
  useEffect(function () {
    if (stickySearchEnabled) {
      var stickyFilter = readFilters(productId);
      stickyFilter[filterType] = filters;
      storeFilters(productId, stickyFilter);
    }
  }, [stickySearchEnabled, readFilters, storeFilters, productId, filterType, filters]);
  return {
    availableFilters: filters,
    isLoading: isLoading && defaultFilters.length === 0,
    loadDefaultFilters: loadDefaultFilters,
    addFilters: addFilters,
    updateFilter: updateFilter,
    updateSingleValueFilter: updateSingleValueFilter,
    clearFilter: clearFilter,
    reset: resetFilter,
    dispatch: dispatch,
    setDefaultFilters: setDefaultFilters
  };
};